import React, { useState, useRef, useEffect, useMemo } from 'react';
import { StyledLeadContainer, CreateLeadFooter, StyledSubHeader, StyledGridContainer } from '../../../Components/Styled/index';
import { Box, Button, Stack, Typography } from '@mui/material';
import LeadAccordion from '../../../Components/LeadAccordion';
import LeadDialog from '../../../Components/LeadDialog';
import moment from 'moment';
import { privateRoutesPath } from '../../../Routes';
import { useSnackbar } from 'notistack';
import { createRequestData, getEntityColumns, validateFields } from '../../../Utility/apiHelper';
import { useDispatch, useSelector } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../../Store/Global/action';
import { requestGetAllCustomers } from '../../../Store/Customer/action';
import BiztantuLoader from '../../../Components/Loader';
import { handleValidateCodevalue, STATIC_ENTITY_CONFIG, ADDITIONAL_ATTRIBUTE_FIELDS, I18N_TASK_PARENT_TASK, TaskSystemLookUp, TASK_PRIORITY, searchEntity } from '../../../Utility/constant';
import { EntityNote } from '../../../Components/EntityNote';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import { useIsMobile } from '../../../Utility/hooks/useIsMobile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import { formatAdditionalAttributesForPayload } from '../../../Utility/payloadFormatter';
import CustomizableFields from '../../../Components/CustomizableFields';
import useTaskLookups from '../../../Utility/hooks/useTaskLookups';
import useNavigation from '../../../Utility/hooks/useNavigation';
import './Tasks.css';

const CreateTasks = (props) => {
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const myTeam = useSelector(state => state?.owner?.Team);
    const customerdropdown = useSelector(state => state?.customer?.customer);
    
    const {
        taskPrimaryTypeData,
        taskSecondaryTypeData,
        taskStatusData,
        taskSourceData,
        openTaskStatus,
        eligibleParentTasks,
    } = useTaskLookups();

    const parentTaskIdFromRoute = props.location?.state?.parentTaskId;
    const parentTaskDetail = props.location?.state?.parentTaskDetail;
    const isMobile = useIsMobile();
    
    const { navigateTo, goBackTo } = useNavigation();
    const [taskDetails, setTaskDetails] = useState(
        parentTaskDetail
            ? {
                  // Spread all parent fields (automatically picks up any future fields too)
                  ...parentTaskDetail,
                  // Override: prefixed description
                  description: `(Sub Task) ${parentTaskDetail.description || ''}`,
                  // Override: blank owner - must be explicitly chosen for subtask
                  ownerId: null,
                  selectedOwner: null,
                  // Override: link to parent task
                  parentTaskId: parentTaskDetail.id,
                  parentTask: { id: parentTaskDetail.id, description: parentTaskDetail.description },
                  // Auto-populate first activity fields from parent
                  activityNote: 'Sub task created',
                  nextFollowupDate: parentTaskDetail?.nextFollowupDate || props.location?.state?.parentNextFollowupDate || '',
              }
            : {
                  ownerId: currentUser?.userId,
                  parentTaskId: parentTaskIdFromRoute || null,
              }
    );
    const [isRequired, setRequiredValue] = useState(false);
    const [requiredActivity, setRequiredActivity] = useState({
        activityNote: false,
        nextFollowupDate: false
    });
    const [dateWarningDialog, setDateWarningDialog] = useState({
        open: false,
    });
    const parentCreatedAt = props.location?.state?.parentCreatedAt || parentTaskDetail?.parentCreatedAt || parentTaskDetail?.createdAt;
    const parentLatestFollowupDate = props.location?.state?.parentNextFollowupDate || parentTaskDetail?.parentNextFollowupDate || parentTaskDetail?.nextFollowupDate;
    const lastValidDateRef = useRef(
        parentTaskDetail?.nextFollowupDate || props.location?.state?.parentNextFollowupDate || ''
    );
    const confirmedDateRef = useRef(null);
    const taskData = props.location.state;
    const hasPrefilledData = useRef(false);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const taskTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "TASK");
        const sourceData = Object.keys(data).length > 0 ? data: STATIC_ENTITY_CONFIG?.TASK;   
        const { id, ...rest } = sourceData;
            return rest;
    }, [allEntityData]);

   useEffect(() => {
        const customerId = taskData?.currentTaskDetail?.id;
            if(customerId && !hasPrefilledData.current && customerdropdown?.length > 0 && taskPrimaryTypeData?.length > 0) {
            const selectedCustomer = customerdropdown.find(item=> item?.id === customerId);
            const serviceRequestType = taskPrimaryTypeData?.find(
                item => item?.systemLookupCode?.name === "TASK_PT_SR"
            );
            
            setTaskDetails(prev=>({
                ...prev,
                selectedCustomer: selectedCustomer,
                customerId: selectedCustomer?.id,
                primaryType: serviceRequestType?.name || '', 
            }));
            
            hasPrefilledData.current = true;
        }
    },[customerdropdown, taskPrimaryTypeData])


    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(requestGetAllCustomers());
    }, [dispatch]);

    useEffect(() => {
        if (parentTaskIdFromRoute) {
            const matchedParent = eligibleParentTasks?.find(item => item?.id === parentTaskIdFromRoute);
            setTaskDetails(prev => {
                if (prev.parentTaskId === parentTaskIdFromRoute && prev.parentTask && (!matchedParent || prev.parentTask?.id === matchedParent?.id)) {
                    return prev;
                }
                return {
                    ...prev,
                    parentTaskId: parentTaskIdFromRoute,
                    parentTask: matchedParent || prev.parentTask || { id: parentTaskIdFromRoute, description: `Task #${parentTaskIdFromRoute}` }
                };
            });
        }
    }, [parentTaskIdFromRoute, eligibleParentTasks]);
    const { enqueueSnackbar } = useSnackbar();
    const inputRef = useRef(null);
    const activityRef = useRef(null);
    const dateInputRef = useRef(null);

const goBack = () => goBackTo(privateRoutesPath.TASKS, searchEntity.task);


    useEffect(()=>{
        if(openTaskStatus){
            setTaskDetails(prev=>({
                ...prev,
                status : openTaskStatus?.name,
            }))
        }
    },[openTaskStatus])

    useEffect(() => {
        // Skip auto-assigning owner when creating a subtask — owner must be explicitly chosen
        if (currentUser?.userId && !parentTaskDetail) {
            const filteredOwner = ((specificRolePermission?.isAllTaskManage ? ownerlist
                : specificRolePermission?.isTaskTeamManage ? myTeam
                : [{
                    firstName: `${currentUser?.firstname}`,
                    lastName: `${currentUser?.lastname}`,
                    id: currentUser?.userId,
                }]) || [])?.find(item => currentUser?.userId === item?.id);
            
            setTaskDetails((detail) => ({
                ...detail,
                selectedOwner: filteredOwner,
                ownerId: filteredOwner?.id
            }));
        }
    }, [currentUser, ownerlist, myTeam]);

    const handleOnChange = (event) => {
        const { name, value } = event?.target;
        setTaskDetails(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSelectOwner = (event, Owner) => {
        setTaskDetails(prev => ({
            ...prev,
            selectedOwner: Owner,
            ownerId: Owner?.id
        }));
    }

    const handleSelectCustomer = (event, Customer) => {
        setTaskDetails(prev => ({
            ...prev,
            selectedCustomer: Customer,
            customerId: Customer?.id
        }));
    }

    const validateTask = () => {
        if (!taskDetails?.description || !taskDetails?.ownerId || !taskDetails?.primaryType || 
            !taskDetails?.secondaryType || !taskDetails?.status) {
            return false;
        }
        return true;
    }

    useEffect(() => {
        const inputEl = dateInputRef.current?.querySelector('input') ?? dateInputRef.current;
        if (!inputEl) return;

        const onNativeChange = (e) => {
            const value = e.target.value;
            if (!value || value.length !== 10 || !moment(value, 'YYYY-MM-DD', true).isValid()) return;

            if (isDateOutOfParentRange(value)) {
                if (value === confirmedDateRef.current) return;
                setDateWarningDialog({
                    open: true,
                    pendingDate: value,
                    previousDate: lastValidDateRef.current || parentLatestFollowupDate || '',
                });
            } else {
                lastValidDateRef.current = value;
                confirmedDateRef.current = null;
            }
        };

        inputEl.addEventListener('change', onNativeChange);
        return () => inputEl.removeEventListener('change', onNativeChange);
    }, [parentCreatedAt, parentLatestFollowupDate]);

    const isDateOutOfParentRange = (dateToCheck = taskDetails?.nextFollowupDate) => {
        if (!dateToCheck) return false;
        const current = moment(dateToCheck, 'YYYY-MM-DD');
        if (!current.isValid()) return false;

        if (parentCreatedAt) {
            const created = moment(parentCreatedAt);
            if (created.isValid() && current.isBefore(created, 'day')) {
                return true;
            }
        }

        if (parentLatestFollowupDate) {
            const followup = moment(parentLatestFollowupDate);
            if (followup.isValid() && current.isAfter(followup, 'day')) {
                return true;
            }
        }

        return false;
    };

    const handleRejectDate = () => {
        const revertTo = dateWarningDialog.previousDate || '';
        setTaskDetails(prev => ({
            ...prev,
            nextFollowupDate: revertTo
        }));
        setDateWarningDialog({ open: false });
    };

    const handleConfirmDate = () => {
        // User accepts the out-of-range date — just keep it in the field, do NOT save
        confirmedDateRef.current = dateWarningDialog.pendingDate;
        lastValidDateRef.current = dateWarningDialog.pendingDate;
        setDateWarningDialog({ open: false });
    };

    const executeCreateTask = async () => {
        dispatch(requestShowLoader());
        const payload = formatAdditionalAttributesForPayload(
            {
               ...taskDetails,
            description: taskDetails?.description,
            ownerId: taskDetails?.ownerId,
            customerId: taskDetails?.customerId || null,
            specialNote: taskDetails?.specialNote || "",
            primaryType: taskDetails?.primaryType,
            secondaryType: taskDetails?.secondaryType,
            status: taskDetails?.status,
            source: taskDetails?.source || null,
            priority: taskDetails?.priority || null,
            parentTaskId: taskDetails?.parentTaskId || null,
            customerId: taskDetails?.selectedCustomer?.id,
            taskActivity: {
                status: taskDetails?.status,
                note: taskDetails?.activityNote,
                nextFollowupDate: taskDetails?.nextFollowupDate || null
            }
            },
            ADDITIONAL_ATTRIBUTE_FIELDS
        );

        try {
            const url = `${process.env.REACT_APP_BASE_URL}tasks/create`;
            const response = await createRequestData(payload, url);

            if (response?.data?.id) {
                dispatch(requestHideLoader());
                enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_CREATED_SUCCESSFULLY'), { variant: 'success' });
                
                setRequiredActivity({
                    activityNote: false,
                    nextFollowupDate: false
                });
                
                navigateTo(`${privateRoutesPath.EDIT_TASK}/${response?.data?.id}`,{},searchEntity?.task);
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise, response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            }
        } catch (error) {
            dispatch(requestHideLoader());
            if (error?.response?.status !== 401) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, error?.response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            }
        }
        finally {
            dispatch(requestHideLoader());
        }
    };

    const handleSave = async () => {
        const {errors,hasError} = validateFields(taskTextfieldsData, taskDetails);
        if(hasError) {
            setRequiredValue(errors);
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"), { variant: "error" });
            return;
        }

        if (!taskDetails?.activityNote) {
            setRequiredActivity({
                activityNote: true,
                nextFollowupDate: true
            });
            activityRef?.current?.focus();
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"), { variant: "error" });
            return;
        }

        if (
            taskDetails?.nextFollowupDate &&
            isDateOutOfParentRange(taskDetails.nextFollowupDate) &&
            taskDetails.nextFollowupDate !== confirmedDateRef.current
        ) {
            setDateWarningDialog({
                open: true,
                pendingDate: taskDetails.nextFollowupDate,
                previousDate: lastValidDateRef.current || parentLatestFollowupDate || '',
            });
            return;
        }

        await executeCreateTask();
    };

const configLabels = STATIC_ENTITY_CONFIG?.TASK

    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
            <Box className={isMobile ?  'globalBoxMobile' : 'globalBox'}>
                <StyledSubHeader>
                    {handleValidateCodevalue(internationalise, 'TASK_EDIT_TASK_DETAILS')}
                </StyledSubHeader>

                {/* Owner and Status Row */}
                <StyledGridContainer>
                    <AutoCompleteComponent
                        isOwner={true}
                        optionSet={(specificRolePermission?.isAllTaskManage ? ownerlist
                            : specificRolePermission?.isTaskTeamManage ? myTeam
                            : [{
                                firstName: `${currentUser?.firstname}`,
                                lastName: `${currentUser?.lastname}`,
                                id: currentUser?.userId,
                            }]) || []}
                        value={taskDetails?.selectedOwner || null}
                        disabled={!(specificRolePermission?.isAllTaskManage || specificRolePermission?.isTaskTeamManage)}
                        name="selectedOwner"
                        placeholder={handleValidateCodevalue(internationalise, configLabels?.selectedOwner?.label)}
                        error={taskDetails?.selectedOwner ? false : Boolean(isRequired?.selectedOwner || isRequired?.ownerId)}
                        required={true}
                        label={handleValidateCodevalue(internationalise, configLabels?.selectedOwner?.label)}
                        onChange={handleSelectOwner}
                    />
                    <AutoCompleteComponent
                        disabled={Boolean(parentTaskIdFromRoute)}
                        optionSet={eligibleParentTasks || []}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        value={taskDetails?.parentTask || null}
                        name="parentTaskId"
                        placeholder={handleValidateCodevalue(internationalise, I18N_TASK_PARENT_TASK) || 'Parent Task'}
                        label={handleValidateCodevalue(internationalise, I18N_TASK_PARENT_TASK) || 'Parent Task'}
                        getOptionLabel={(option) =>
                            option ? `${option.id} - ${(option.description || '').substring(0, 60)}` : ''
                        }
                        onChange={(_, task) => {
                            setTaskDetails(prev => ({
                                ...prev,
                                parentTaskId: task?.id || null,
                                parentTask: task || null,
                            }));
                        }}
                    />
                     <AutoCompleteComponent
                        isOwner={true}
                        optionSet={customerdropdown || []}
                        value={taskDetails?.selectedCustomer || null}
                        name="customerId"
                        placeholder={handleValidateCodevalue(internationalise, configLabels?.selectedCustomer?.label)}
                        label={handleValidateCodevalue(internationalise,configLabels?.selectedCustomer?.label)}
                        onChange={handleSelectCustomer}
                    />
                    <SelectBoxWithLabel
                        select
                        required={true}
                        name="status"
                        value={taskDetails?.status || ''}
                        disabled
                        label={handleValidateCodevalue(internationalise,configLabels?.status?.label)}
                        error={taskDetails?.status ? false : isRequired?.status}
                        optionMenuItem={taskStatusData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}

                    />
                    <SelectBoxWithLabel
                        select
                        required={true}
                        name="primaryType"
                        value={taskDetails?.primaryType || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.primaryType?.label)}
                        error={taskDetails?.primaryType ? false : isRequired?.primaryType}
                        optionMenuItem={taskPrimaryTypeData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}

                    />
                    <SelectBoxWithLabel
                        select
                        required={true}
                        name="secondaryType"
                        value={taskDetails?.secondaryType || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.secondaryType?.label)}
                        error={taskDetails?.secondaryType ? false : isRequired?.secondaryType}
                        optionMenuItem={taskSecondaryTypeData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}


                    />
                                       
                    {taskTextfieldsData?.source?.visibility && 
                    <SelectBoxWithLabel
                        select
                        name="source"
                        required = {taskTextfieldsData?.source?.mandatory}
                        error={taskDetails?.source ? false : !!isRequired?.source}
                        value={taskDetails?.source || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.source?.label)}
                        optionMenuItem={taskSourceData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}
                    />
                    }
                      <SelectBoxWithLabel
                        select
                        name="priority"
                        value={taskDetails?.priority || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.priority?.label)}
                        optionMenuItem={TASK_PRIORITY}
                        handleOnChange={handleOnChange}
                        isStatic={true}
                        ownerdropdown={false}
                    />
                </StyledGridContainer>
                <CustomizableFields
                    CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                    entity = "TASK"
                    config={taskTextfieldsData}
                    values={taskDetails}
                    setValues={setTaskDetails}
                    handleOnChange={handleOnChange}
                    errors={isRequired}
                />
               

                {/* Description Row */}
                <StyledLeadContainer>
                    <TextFiledWithLabel
                        label={handleValidateCodevalue(internationalise, 'TASK_EDIT_DESCRIPTION')}
                        name="description"
                        inputRef={inputRef}
                        required={true}
                        error={taskDetails?.description ? false : isRequired?.description}
                        value={taskDetails?.description || ''}
                        handleOnChange={handleOnChange}
                        className="create-task-description"
                    />
                </StyledLeadContainer>

                {/* Special Note */}
                <EntityNote
                    entityDetails={taskDetails}
                    name="specialNote"
                    onChange={handleOnChange}
                    headingLabel={handleValidateCodevalue(internationalise, "COMMON_SPECIAL_NOTE")}
                />

                {/* Task Activities Accordion */}
                <LeadAccordion
                    label={handleValidateCodevalue(internationalise, 'TASK_EDIT_ACTIVITIES')}
                    defaultOpen={true}
                >
                    <StyledLeadContainer>
                        <TextFiledWithLabel
                            id="activity-note"
                            label={handleValidateCodevalue(internationalise, "TASK_EDIT_ACTIVITY_NOTE")}
                            inputRef={activityRef}
                            required={true}
                            name="activityNote"
                            value={taskDetails?.activityNote || ''}
                            handleOnChange={handleOnChange}
                            error={taskDetails?.activityNote ? false : requiredActivity?.activityNote}
                            className="create-task-activity-note"
                        />
                        <div ref={dateInputRef}>
                            <TextFiledWithLabel
                                className={`${isMobile ? 'mt-15 ' : ''}create-task-activity-date`}
                                id="next-followup-date"
                                type="date"
                                name="nextFollowupDate"
                                value={taskDetails?.nextFollowupDate || ''}
                                label={handleValidateCodevalue(internationalise, "TASK_NEXT_FOLLOWUP_DATE")}
                                handleOnChange={handleOnChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    </StyledLeadContainer>
                </LeadAccordion>
            </Box>
                {/* Footer Buttons */}
                <CreateLeadFooter>
                    <Stack alignItems="center" display={"flex"} flexWrap={isMobile ? "nowrap" : "wrap"} gap={isMobile ? "0px" : "5px"} justifyContent={"space-between"} flexDirection="row">
                        <Typography variant='h6'>
                            {handleValidateCodevalue(internationalise, taskDetails?.parentTaskId ? 'SUBTASK_EDIT_TITLE_CREATE' : 'TASK_EDIT_TITLE_CREATE')}
                        </Typography>
                    {isMobile &&
                       <>
                       <Button 
                               className="edit-primary btn-space"
                               variant="outlined"
                               onClick={goBack}
                           >
                               <ArrowBackIcon />
                           </Button>
                           <Button
                               className="edit-primary"
                               variant="outlined"
                               onClick={handleSave}
                           >
                               <CheckIcon />
                           </Button>
                           </>
                        }   
                        {!isMobile &&
                        <>
                        <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>
                            {handleValidateCodevalue(internationalise, 'COMMON_BACK')}
                        </Button>
                        <Button className='edit-primary' variant="outlined" onClick={handleSave}>
                            {handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
                        </Button>
                        </>
                        }
                    </Stack>
                </CreateLeadFooter>
                {dateWarningDialog.open && (
                    <LeadDialog
                        open={dateWarningDialog.open}
                        handleClose={handleRejectDate}
                        handleSave={handleConfirmDate}
                        title={handleValidateCodevalue(internationalise, 'TASK_SUBTASK_FOLLOWUP_DATE_WARNING_TITLE') }
                        size="sm"
                        btnlabel={handleValidateCodevalue(internationalise, 'COMMON_YES')}
                        alternateBtnLabel={handleValidateCodevalue(internationalise, 'COMMON_CANCEL')}
                    >
                        <Typography gutterBottom>
                            {handleValidateCodevalue(internationalise, 'TASK_SUBTASK_FOLLOWUP_DATE_WARNING_DESC') }
                        </Typography>
                    </LeadDialog>
                )}
        </BiztantuLoader>
    );
}

export default CreateTasks;
